import { useMemo } from 'react';
import { isSubtaskHierarchyLevel } from '@atlassian/jira-issue-type-hierarchies/src/index.tsx';
import { useBacklogSelector } from '../../../../../../state/index.tsx';
import { getCards } from '../../../../../../state/selectors/cards/index.tsx';

const useCardsIncludeSubtasksWithoutParents = (cardIds: number[]) => {
	const selectedCards = useBacklogSelector((state) => {
		const allCards = getCards(state);
		return cardIds.map((cardId) => allCards[cardId]).filter(Boolean);
	});

	const selectedSubtasks = useMemo(
		() =>
			selectedCards.filter(({ typeHierarchyLevel }) => isSubtaskHierarchyLevel(typeHierarchyLevel)),
		[selectedCards],
	);

	return useMemo(
		() => selectedSubtasks.some(({ parentId }) => parentId && !cardIds.includes(parentId)),
		[cardIds, selectedSubtasks],
	);
};

export default useCardsIncludeSubtasksWithoutParents;
